import React from 'react';
import { Paper, Typography, Skeleton, Box, Tooltip } from '@mui/material';

const COLORS = ['#1976d2', '#2196f3', '#64b5f6', '#90caf9', '#bbdefb'];

const TopProductsChart = ({ data = [], loading }) => {
  const maxQuantity = Math.max(...data.map((item) => Number(item.quantity) || 0), 1);

  return (
    <Paper elevation={2} sx={{ p: 2, height: 360, display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle1" sx={{ mb: 1.5, flexShrink: 0 }}>
        Productos más vendidos
      </Typography>

      <Box sx={{ width: '100%', flex: 1, minHeight: 0 }}>
        {loading ? (
          <Skeleton variant="rectangular" width="100%" height="100%" />
        ) : data.length > 0 ? (
          <Box
            sx={{
              height: '100%',
              overflowY: 'auto',
              overflowX: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              gap: 1.25,
              pt: 0.5,
              pr: 0.5,
              scrollbarGutter: 'stable',
            }}
          >
            {data.slice(0, 10).map((item, index) => {
              const quantity = Number(item.quantity) || 0;
              const percent = Math.max((quantity / maxQuantity) * 100, 2);
              const color = COLORS[index % COLORS.length];

              return (
                <Box key={`${item.product}-${index}`} sx={{ minWidth: 0 }}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Tooltip title={item.product || 'Producto'} arrow placement="top">
                      <Typography
                        variant="caption"
                        sx={{
                          flex: 1,
                          minWidth: 0,
                          fontWeight: 600,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {item.product || 'Producto'}
                      </Typography>
                    </Tooltip>
                    <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
                      {quantity}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      mt: 0.25,
                      height: 8,
                      borderRadius: 999,
                      bgcolor: 'grey.200',
                      overflow: 'hidden',
                    }}
                  >
                    <Box
                      sx={{
                        width: `${percent}%`,
                        height: '100%',
                        borderRadius: 999,
                        bgcolor: color,
                      }}
                    />
                  </Box>
                </Box>
              );
            })}
          </Box>
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="textSecondary">
              No hay datos disponibles.
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default TopProductsChart;
